import { useContext } from 'react'

import {
  GlobalTextContext,
  IGlobalTextContext,
} from '../providers/GlobalTextProvider'

export default function useGlobalText(): IGlobalTextContext {
  const { getText } = useContext(GlobalTextContext)

  return { getText }
}
